module.exports = __webpack_public_path__ + "static/media/iguazu-falls-39.82dde57f.jpg";